import type { ScheduleTask } from '../../../services/scheduleService';

/** Minimal row shape for SVAR link building (task rows with optional completion dependency). */
export type ScheduleGanttDependencyRow = {
  id: number;
  sourceTaskId?: number | null;
  dependencies?: ScheduleTask['dependencies'] | null;
};

export type SvarScheduleLink = { id: number; source: number; target: number; type: 'e2s' };

/**
 * Finish-to-start links: predecessor (completionTaskId) → dependent row,
 * using the first Gantt row id per API `sourceTaskId`.
 */
export function buildSvarDependencyLinks(rows: ScheduleGanttDependencyRow[]): SvarScheduleLink[] {
  const list = Array.isArray(rows) ? rows : [];
  const taskIdToNodeId = new Map<number, number>();
  list.forEach((t) => {
    if (t.sourceTaskId && !taskIdToNodeId.has(t.sourceTaskId)) {
      taskIdToNodeId.set(t.sourceTaskId, t.id);
    }
  });
  const links: SvarScheduleLink[] = [];
  let nextId = 1;
  list.forEach((t) => {
    const completionTaskId = t.dependencies?.completionTaskId;
    if (!t.sourceTaskId || !completionTaskId) return;
    const predecessorRowId = taskIdToNodeId.get(Number(completionTaskId));
    if (!predecessorRowId || predecessorRowId === t.id) return;
    links.push({
      id: nextId++,
      source: predecessorRowId,
      target: t.id,
      type: 'e2s',
    });
  });
  return links;
}
